module.exports = __webpack_public_path__ + "static/media/login.2dc18675.svg";